<template>
  <div class="manageSave">
    <!-- 添加用户 -->
    <div class="info">
      <p class="title">添加账号</p>
    </div>
    <div class="form-box">
      <el-form
        ref="addAccount"
        :model="accountInfo"
        :rules="rules"
        :hide-required-asterisk="true"
        label-position="left"
        label-width="55px">
        <el-form-item label="姓名" class="required" prop="name">
          <el-input
            v-model="accountInfo.name"
            placeholder="填写姓名"></el-input>
        </el-form-item>
        <el-form-item label="部门" class="required" prop="department">
          <el-input
            v-model="accountInfo.department"
            autocomplete="off"
            placeholder="填写部门"></el-input>
        </el-form-item>
        <el-form-item label="职位" class="required" prop="position">
          <el-input
            v-model="accountInfo.position"
            autocomplete="off"
            placeholder="填写职位"></el-input>
        </el-form-item>
        <el-form-item label="手机" class="required" prop="mobile">
          <el-input
            maxlength="11"
            v-model.number="accountInfo.mobile"
            autocomplete="off"
            placeholder="手机"></el-input>
        </el-form-item>
		<el-form-item label="性别" class="required" prop="sex">
		  <el-select v-model="accountInfo.sex" placeholder="请选择性别" style="width: 100%;">
		  	<el-option label="先生" value="先生"></el-option>
		  	<el-option label="女士" value="女士"></el-option>
		  </el-select>
		</el-form-item>
        <el-form-item label="座机" class="required" prop="tel">
          <el-input
            v-model.number="accountInfo.tel"
            autocomplete="off"
            placeholder="座机"></el-input>
        </el-form-item>
      </el-form>
    </div>
	<button class="add" style="background-color: #f3f3f3;color: black;margin-right: 0px;" @click="cancel">返回</button>
    <button class="add" @click="manageSave">保存</button>
  </div>
</template>

<script>
import {Api} from "../../utils/axios.js"
import { telRegExp } from '@/utils/regExp'
export default {
  data() {
    return {
      accountInfo: {
        username: '',
        name: '',
        department: '',
        position: '',
        mobile: '',
        tel: '',
		sex:'先生'
      },
      rules: {
        username: [
          {
            required: true,
            message: '请输入邮箱地址'
          },
          {
            type: 'email',
            message: '请输入正确的邮箱地址'
          }
        ],
        name: {
          required: true,
          message: '请填写姓名'
        },
        department: {
          required: true,
          message: '请填写部门'
        },
        position: {
          required: true,
          message: '请填写职位'
        },
        mobile: {
          validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error('请输入手机号码'))
            } else {
              if (!telRegExp.test(value)) {
                callback(new Error('请输入正确的手机号码'))
              }
              callback()
            }
          }
        },
        tel: {
          required: true,
          message: '请填写座机'
        }
      }
    }
  },
  methods: {
    manageSave() {
      this.$refs['addAccount'].validate(async valid => {
        if (valid) {
          /* const res = await usermanageSave(this.accountInfo)
          if (res.code != 200) return
          this.$message({
            message: res.msg,
            type: 'success'
          }) */
		  let params = this.accountInfo;
		  const loading = this.$loading({lock: true,text: '数据保存中...',});
		  Api('user/manageSave',params).then((res) => {
		  	console.log(res);
		  	if(res.code==200){
		  		if(res.result.save == true){
		  			var that = this;
		  			this.$message({message: '保存成功!',type: 'success',duration:1000,onClose:function(){
		  				loading.close();
		  				history.back()
		  			}});
		  		}
		  	}else{
		  		this.$message.error(res.msg);
		  		loading.close();
		  	}
		  })
        }
      })
    },
	cancel(){
		history.back()
	}
  }
}
</script>

<style scoped>
:deep(.el-input__inner) {
  height: 34px;
  background: #f9f9f9;
  border: 1px solid #efefef;
  border-radius: 2px;
}
:deep(.required .el-form-item__label::after) {
  content: '*';
  color: #db221a;
}
.form-box {
  margin-top: 30px;
}
.manageSave {
  background-color: #ffffff;
  padding: 20px;
  border-radius: 10px;
  .info {
    .title {
      background-image: linear-gradient(to right, #4a73ff 4px, transparent 4px);
      padding-left: 14px;
      font-size: 18px;
      font-weight: 600;
    }
  }
  .userinfo {
    display: flex;
    margin-top: 20px;
    .title {
      font-size: 15px;
      font-weight: 500;
      margin-right: 15px;
      margin-top: 5px;
    }
    input {
      width: 90%;
      height: 31px;
      padding-left: 10px;
      background-color: #f9f9f9;
      border: 1px solid #efefef;
      outline: none;
    }
  }
}
.add {
  width: 120px;
  height: 40px;
  background: #4a73ff;
  border-radius: 6px;
  border: none;
  font-weight: bold;
  color: #ffffff;
  margin-top: 45px;
  margin-right: 40px;
  float: right;
  text-align: center;
  cursor: pointer;
}
</style>
